/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type useEligibleSecondChanceOfferState_item = {
    readonly secondChanceEligibleAuctionLot: {
        readonly buyItNowPrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
            } | null> | null;
        } | null;
        readonly reservePrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
            } | null> | null;
        } | null;
    } | null;
    readonly secondChanceEligibleAuctionSolution: {
        readonly reserveMet: boolean | null;
        readonly totalUniqueBidders: number | null;
        readonly bids: {
            readonly totalResults: number | null;
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly amount: {
                        readonly convertedAmountList: ReadonlyArray<{
                            readonly amount: number | null;
                            readonly currency: Currency | null;
                        } | null> | null;
                    } | null;
                } | null;
            } | null> | null;
        } | null;
        readonly highestBidAmount: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "useEligibleSecondChanceOfferState_item";
};
export type useEligibleSecondChanceOfferState_item$data = useEligibleSecondChanceOfferState_item;
export type useEligibleSecondChanceOfferState_item$key = {
    readonly " $data"?: useEligibleSecondChanceOfferState_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"useEligibleSecondChanceOfferState_item">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useEligibleSecondChanceOfferState_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuctionLot",
      "kind": "LinkedField",
      "name": "secondChanceEligibleAuctionLot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "buyItNowPrice",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "reservePrice",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "secondChanceEligibleAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reserveMet",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalUniqueBidders",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuctionBidsConnection",
          "kind": "LinkedField",
          "name": "bids",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalResults",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AuctionBidsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuctionBid",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FinancialAmount",
                      "kind": "LinkedField",
                      "name": "amount",
                      "plural": false,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "highestBidAmount",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = 'bb80d26be5ce640bebebb064eab4dd82';
export default node;
